// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__YAH-6","disabled":"Checkbox_disabled__aT6Dx","button":"Checkbox_button__+n-lN","label":"Checkbox_label__TOTc3","hasError":"Checkbox_hasError__nbxe9"};